<template>
	<div class="success-designation-screen">

    <div>
      <div class="hipaa-icon-tooth-pc" style="font-size: 90px"></div>
    </div>
		<p v-if="designation">
			You have accepted the role and responsibilities of
			{{ designation?.role[1] }}.
		</p>
		<p v-if="adminEmail.length > 0">We have sent a verification link to {{ adminEmail || 'THERE IS NO EMAIL SETTED' }}</p>
		<p>
			Please use your desktop computer to access the administrative features
			of Bite-Size HIPAA.
		</p>
	</div>
</template>

<script>
export default {
	props: {
		designation: Object,
		adminEmail: String,
	},
};
</script>

<style lang="scss">
@import '@/sass/_vars.scss';

.success-designation-screen {

	svg {
		width: 130px;
		// color: var(--primary-color);
	}

	font-size: 17px;
	margin: 0 24px;
	display: flex;
	flex-direction: column;
	text-align: center;
}

.block {
	content: "\e911";
}
</style>
